export default function format(value: number, type: string, scale: string, precision: string): string {
   let decimal: number;
   let pwr: number;
   switch (scale) {
      case 'trillions':
         (pwr = 12), (decimal = precision === 'Auto' ? 3 : Number(precision));
         break;
      case 'billions':
         (pwr = 9), (decimal = precision === 'Auto' ? 2 : Number(precision));
         break;
      case 'millions':
         (pwr = 6), (decimal = precision === 'Auto' ? 1 : Number(precision));
         break;
      case 'thousands':
         (pwr = 3), (decimal = precision === 'Auto' ? 0 : Number(precision));
         break;
      default:
         (pwr = 0), (decimal = precision === 'Auto' ? 2 : precision ? Number(precision) : 2);
         break;
   }
   if (value === null) {
      return 'N/A';
   }

   switch (type) {
      case 'Currency':
         const formatNumber = global.Intl.NumberFormat('en-us', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal
         });
         return formatNumber.format(value / Math.pow(10, pwr));
      case 'Percentage':
         decimal = precision === 'Auto' ? 1 : Number(precision);
         return global.Intl.NumberFormat('en-us', {
            style: 'percent',
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal
         }).format(value / 100);

      case 'Time':
         decimal = precision === 'Auto' ? 2 : Number(precision);
         return global.Intl.NumberFormat('en-us', {
            style: 'decimal',
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal
         }).format(value);
      default: // also 'Number'
         return global.Intl.NumberFormat('en-us', {
            style: 'decimal',
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal
         }).format(value / Math.pow(10, pwr));
   }
}
